import React from 'react'

import * as S from './styles'

function Inputkeleton (props) {
  return <S.InputkeletonContainer />
}

export default Inputkeleton
